import React from "react";
import { Container } from "reactstrap";

import FooterInscription from "../../FooterInscription";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <FooterInscription />
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
